<template>
    <div class="flex items-center gap-1 w-full">
        <Breadcrumb :home="{ type: 'home', disabled: true}" :model="breadItems">
            <template #item="{ item, props }">
                <div v-if="!item.disabled">
                    <Button variant="text" rounded :label="item.label"
                            @click="gotoWorkspace(item)"></Button>
                </div>
                <div v-else>
                    <span :class="[item.icon, 'text-color']"/>
                    <span class="text-primary">{{ item.label }}</span>
                </div>
            </template>
        </Breadcrumb>

    </div>
</template>
<script setup>
import {computed, onMounted} from 'vue'

import {useStore} from "vuex";

const store = useStore()
import {useRouter} from 'vue-router'

const router = useRouter()
const graphId = computed(() => router.currentRoute.value.params.graphId)

onMounted(async () => {
    await store.dispatch('repoStore/loadWorkspaces')
    if (graphId.value && !selectedGraph.value) {
        const graph = store.state.repoStore.graphMap.get(parseInt(graphId.value))
        await store.dispatch('repoStore/setSelectedGraph', graph)
    }
})

const selectedGraph = computed(() => store.getters["repoStore/getGraph"])

const breadItems = computed(() => {
    if (!graphId.value || !selectedGraph.value) {
        return []
    }
    let items = []
    let el = selectedGraph.value
    while (el) {
        items = [{
            label: el.name,
            disabled: el.workspace_id,
            id: el.id,
            type: el.workspace_id ? 'graph' : 'workspace',
        }, ...items]
        el = el.parent
    }
    return items
})

const gotoWorkspace = (item) => {
    if (item.type !== 'workspace') {
        return
    }
    store.dispatch('repoStore/setSelectedSpace', item.id)
    store.dispatch('repoStore/setSelectedGraph', null)
}


</script>
<style scoped lang="scss">
.graphList {
    background: unset;
    border: unset !important;
    box-shadow: unset !important;
    user-select: none;
    overflow-y: auto;
    height: calc(100vh - 270px);
}

:deep(.p-overlaypanel-content) {
    padding: unset !important;
}

.workspaceSelect {
    width: 59%;
}
</style>